import Vec2 from 'vec2';

import { FabricCanvasContextType } from './fabricCanvas.types';

import { DRAGGING_STATE } from '~/core/enums';

export const initialFabricCanvasContextValue: FabricCanvasContextType = {
  draggingStateRef: { current: DRAGGING_STATE.IDLE },
  drawingShapesRef: { current: [] },
  isShapeLogicRef: { current: true },
  lastPositionRef: { current: {} },
  movingItemRef: { current: undefined },
  shapeStartDragRef: { current: new Vec2(0, 0) },
};
